import UserAccount from '../services/UserAccount';
import LogicBaseCollectionSubscriptionApi from '../services/server/LogicBaseCollectionSubscriptionApi';
import LogicBaseCollectionCache from '../services/cache/LogicBaseCollectionCache';
import LogicBaseAppPinApi from '../services/server/LogicBaseAppPinApi';

const updates = new Set();

export function syncCollectionApps(collection, apps) {
  const filteredApps = apps.filter((a) => a._id);

  // Only sync if the collection apps and apps returned are the same link
  // This ensures that if we paginate this wont cause a bug
  if (
    UserAccount.isLoggedIn
    && (UserAccount.account._id === collection.owner || collection.editors.includes(UserAccount.account._id))
    && collection.apps.length === apps.length
    && apps.find((a) => a.error === 'NotFound')
  ) {
    if (updates.has(collection._id)) return;
    updates.add(collection._id);
    collection.apps = filteredApps.map(({ _id }) => _id);
    LogicBaseCollectionCache.update(collection);
  }

  // Return the filtered apps
  return filteredApps;
}
export function syncCollectionSubscriptions(subscriptions, collections) {
  // Only sync if the user is an owner or editor
  if (
    UserAccount.isLoggedIn
    && subscriptions.currentPage.length === collections.length
    && collections.find((a) => a.error === 'NotFound')
  ) {
    const removeCollections = subscriptions.currentPage.filter((s) => !collections.find(({ _id }) => _id === s.collection));
    removeCollections.forEach((r) => {
      if (updates.has(r._id)) return;
      updates.add(r._id);
      LogicBaseCollectionSubscriptionApi.delete({ _id: r._id });
    });
  }

  // Return the filtered collections
  return collections.filter((a) => a._id);
}
export function syncAppPins(pins, apps) {
  // Only sync if the user is an owner or editor
  if (
    UserAccount.isLoggedIn
    && pins.currentPage.length === apps.length
    && apps.find((a) => a.error === 'NotFound')
  ) {
    const removePins = pins.currentPage.filter((s) => !apps.find(({ _id }) => _id === s.app));
    removePins.forEach((r) => {
      if (updates.has(r._id)) return;
      updates.add(r._id);
      LogicBaseAppPinApi.delete({ _id: r._id });
    });
  }

  // Return the filtered collections
  return apps.filter((a) => a._id);
}
